/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Ronnie Wisawapakorn
 * Created: 17/11/22
 */

import React from 'react';
import { HStack, Text } from '@chakra-ui/react';

interface FieldValueSetProps {
    data: Record<string, string | number | undefined>;
}

const AdminFieldValueSet = ({ data }: FieldValueSetProps) => (
    <>
        {Object.entries(data).map(([key, value]) => (
            <React.Fragment key={key}>
                <HStack spacing={2}>
                    <Text fontSize={'lg'} fontWeight={'semibold'} textColor={'black'}>
                        {key}
                    </Text>
                    <Text fontSize={'lg'}>{value}</Text>
                </HStack>
            </React.Fragment>
        ))}
    </>
);

export default AdminFieldValueSet;
